/** This file is auto generated by convertSvgToJsx.ts */

import icon from './dnb/pin_code_medium'
export default icon
